<script setup lang="ts">
import { computed } from "vue";
import PublicHeader from '@/components/navigation/PublicHeader.vue';
import Footer from '@/components/layout/Footer.vue';
import { useRoute } from "vue-router";
import routeManager from "@/router/route-manager";

const route = useRoute();
const showHeaderFooter = computed<boolean>( () => !( routeManager.isSignInPath( route.path ) ) );
</script>

<template>
    <div class="flex flex-col min-h-dvh">
        <div class="grow">
            <PublicHeader v-if="showHeaderFooter" />
            <slot/>
        </div>
        <Footer v-if="showHeaderFooter" />
    </div>
</template>
